/* eslint-disable eag/no-index -- Pre-existing violation */
export type CardTagSelectionTagType = {
  id: string;
  label: string;
};
